import styled from 'styled-components';

const PaddingContainer = styled.div`
  width: 100%;
  min-height: calc(100vh - 112px);
  display: flex;
  flex-direction: column;
`;

export default PaddingContainer;
